import type { ComponentSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/product/product-detail.schema'

/** Khelaghor product page: the shared fields plus the safety line, "How to order" and the delivery charges. */
export const schema: ComponentSchema = {
  ...shared,
  commonFields: [
    ...shared.commonFields,
    { key: 'safetyText', label: 'Safety line', type: 'string', default: 'Made with child-safe, non-toxic materials', help: 'Shown under the age range on every product. Only promise what is true for all your products; leave empty to hide it.' },
    { key: 'howToOrderTitle', label: '"How to order" title', type: 'string', default: 'How to order' },
    { key: 'howToOrder', label: 'How to order', type: 'localized-text', help: 'Steps folded under the description, one per line; hidden while this is empty.' },
    { key: 'showDeliveryAreas', label: 'Show delivery charges by area', type: 'boolean', default: true, help: 'Listed in the delivery box, from your delivery settings.' },
  ],
}
